import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { CARE, FEATURES, MATERIALS, MEASUREMENTS, RECYCLED_NOTE, RETURNS, SHIPPING } from "../../data/catalog";

const Item = ({ value, title, children }) => (
  <AccordionItem value={value} className="border-line">
    <AccordionTrigger className="py-5 text-[12px] font-medium uppercase tracking-[0.2em] text-ink hover:no-underline" data-testid={`pdp-accordion-${value}`}>{title}</AccordionTrigger>
    <AccordionContent className="text-sm leading-relaxed text-graphite">{children}</AccordionContent>
  </AccordionItem>
);

const Sub = ({ children }) => <p className="mb-2 mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-ink first:mt-0">{children}</p>;

const Rows = ({ rows, testid }) => (
  <dl className="divide-y divide-line" data-testid={testid}>
    {rows.map(([k, v]) => (
      <div key={k} className="grid grid-cols-[120px_1fr] gap-4 py-3"><dt className="text-ink">{k}</dt><dd>{v}</dd></div>
    ))}
  </dl>
);

export const Details = () => (
  <Accordion type="multiple" defaultValue={["details"]} className="border-t border-line" data-testid="pdp-details">
    <Item value="details" title="Details">
      <Sub>Measurements</Sub>
      <Rows rows={MEASUREMENTS} testid="pdp-measurements" />
      <Sub>Product features</Sub>
      <ul className="list-disc space-y-1 pl-5" data-testid="pdp-features">{FEATURES.map((f) => <li key={f}>{f}</li>)}</ul>
      <div className="mt-4 grid grid-cols-2 gap-2">
        <img src="/img/v-inside.webp" alt="Inside the MARKHOR bag" className="aspect-[4/3] w-full object-cover" />
        <img src="/img/v-pockets.webp" alt="MARKHOR interior pockets and label" className="aspect-[4/3] w-full object-cover" />
      </div>
    </Item>
    <Item value="materials" title="Materials & care">
      <Sub>Materials</Sub>
      <Rows rows={MATERIALS} testid="pdp-materials" />
      <Sub>Care</Sub>
      <ul className="list-disc space-y-1 pl-5" data-testid="pdp-care">{CARE.map((c) => <li key={c}>{c}</li>)}</ul>
      <p className="mt-4 border-t border-line pt-4 text-ink">{RECYCLED_NOTE}</p>
    </Item>
    <Item value="shipping" title="Shipping & returns">
      <p>At MARKHOR, we're committed to delivering your order with care and convenience.</p>
      <Sub>Shipping</Sub>
      <Rows rows={SHIPPING} testid="pdp-shipping" />
      <Sub>Returns & exchanges</Sub>
      <p className="mb-2">We want you to shop with confidence.</p>
      <Rows rows={RETURNS} testid="pdp-returns" />
      <p className="mt-4">To request a return or exchange, please contact <a href="mailto:support@shopmarkhor.com" className="text-ink underline underline-offset-4" data-testid="pdp-returns-support-email">MARKHOR Customer Support</a>.</p>
      <p className="mt-4 border-t border-line pt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-ink">MARKHOR — Wear Confidence. Live Boldly.</p>
    </Item>
  </Accordion>
);
